import { render } from "./MaterialRequestsAdminList.vue?vue&type=template&id=601d9da0&scoped=true"
import script from "./MaterialRequestsAdminList.vue?vue&type=script&lang=js"
export * from "./MaterialRequestsAdminList.vue?vue&type=script&lang=js"

import "./MaterialRequestsAdminList.vue?vue&type=style&index=0&id=601d9da0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-601d9da0"]])

export default __exports__